import { Component, Input } from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
    selector: 'pr-input-checkbox',
    templateUrl: './pr-input-checkbox.component.html',
    styleUrls: ['./pr-input-checkbox.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PrInputCheckboxComponent,
        },
        // {
        //   provide: NG_VALIDATORS,
        //   multi: true,
        //   useExisting: PrInputCheckboxComponent,
        // },
    ],
    standalone: false
})
export class PrInputCheckboxComponent implements ControlValueAccessor {
  @Input() formControlName: string;
  @Input() derrors: boolean = false;
  @Input() label: string;
  value: boolean = false;
  touched = true;
  @Input() disabled = false;
  onChange: any = value => {};
  onTouch: any = () => {};
  checked: boolean = false;
  @Input() required: boolean = false;
  @Input() withBox: boolean = false;
  constructor(private controlContainer: ControlContainer) {}

  get control() {
    return this.controlContainer.control.get(this.formControlName);
  }

  hash =
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);
  get formLabel() {
    return `${this.formControlName}_${this.hash}`;
  }

  ngOnInit() {
    if (this.control) this.value = this.control.value || false;
  }
  onChecked() {
    return this.value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(checked: boolean) {
    this.checked = checked;
    this.value = checked;
  }

  onModelChange(e: any) {
    this.checked = e.target.checked;

    this.onChange(e.target.checked);
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
